export const AtlasMarkBrand = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 42.7982C14.016 42.7982 5.89795 34.6802 5.89795 24.6962C5.89795 14.7122 14.016 6.59424 24 6.59424V9.47624C15.604 9.47624 8.78095 16.2992 8.78095 24.6952C8.78095 33.0912 15.604 39.9142 24 39.9142V42.7962V42.7982Z"
      fill="url(#paint0_linear_818_466)"
    />
    <path
      d="M23.9999 42.7983V39.9163C32.3959 39.9163 39.2189 33.0933 39.2189 24.6973H42.1009C42.1009 34.6813 33.9829 42.7993 23.9989 42.7993L23.9999 42.7983Z"
      fill="url(#paint1_linear_818_466)"
    />
    <path
      d="M42.102 24.6962H39.22C39.22 16.3002 32.397 9.47722 24.001 9.47722V6.59521C33.985 6.59521 42.103 14.7132 42.103 24.6972L42.102 24.6962Z"
      fill="url(#paint2_linear_818_466)"
    />
    <path
      d="M31.711 30.238C29.7889 29.862 28.2719 29.18 25.7509 28.038C25.055 27.732 24.289 27.384 23.412 26.994C22.883 26.757 22.396 26.548 21.908 26.34C18.107 24.655 16.018 23.736 13.4559 23.736C11.6599 23.736 10.3089 24.223 9.55695 25.142C9.04195 25.755 8.83295 26.548 8.98595 27.314L6.15895 27.857C5.85295 26.242 6.26995 24.585 7.32895 23.304C8.24795 22.19 10.0579 20.853 13.4559 20.853C16.6309 20.853 19.1929 21.995 23.0779 23.708C23.5509 23.917 24.039 24.14 24.568 24.362C25.459 24.752 26.239 25.1 26.9349 25.42C29.344 26.506 30.667 27.105 32.268 27.411L31.711 30.238Z"
      fill="url(#paint3_linear_818_466)"
    />
    <path
      d="M34.5259 30.516C33.5649 30.516 32.6459 30.432 31.7129 30.238L32.2699 27.411C33.0219 27.564 33.7599 27.634 34.5259 27.634C36.3079 27.634 37.6589 27.188 38.4389 26.339C39.2189 25.49 39.2469 24.459 39.2049 23.916L42.0729 23.665C42.2259 25.419 41.6969 27.063 40.5689 28.288C39.6359 29.304 37.8399 30.516 34.5259 30.516Z"
      fill="url(#paint4_linear_818_466)"
    />
    <path
      d="M23.9999 42.798V39.916C28.1359 39.916 30.5999 35.697 30.5999 28.637C30.5999 21.577 28.0939 15.659 22.9559 10.187L25.0589 8.20996C30.7259 14.239 33.4829 20.923 33.4829 28.637C33.4829 37.368 29.8489 42.798 23.9999 42.798Z"
      fill="url(#paint5_linear_818_466)"
    />
    <path
      d="M23.998 42.7981C17.774 42.7981 14.209 37.7301 14.209 28.8881C14.209 18.5701 18.721 12.8051 22.94 8.22412L25.057 10.1731C20.142 15.5201 17.092 20.5051 17.092 28.8871C17.092 38.0071 20.852 39.9151 23.999 39.9151V42.7971L23.998 42.7981Z"
      fill="url(#paint6_linear_818_466)"
    />
    <path
      d="M16.2849 26.2C18.1459 26.2 19.6549 24.691 19.6549 22.83C19.6549 20.969 18.1459 19.46 16.2849 19.46C14.4239 19.46 12.9149 20.969 12.9149 22.83C12.9149 24.691 14.4239 26.2 16.2849 26.2Z"
      fill="#1D7AFC"
    />
    <path
      d="M31.8629 32.0071C33.7239 32.0071 35.2329 30.4981 35.2329 28.6371C35.2329 26.7761 33.7239 25.2671 31.8629 25.2671C30.0019 25.2671 28.4929 26.7761 28.4929 28.6371C28.4929 30.4981 30.0019 32.0071 31.8629 32.0071Z"
      fill="#1D7AFC"
    />
    <path
      d="M23.997 11.9412C25.858 11.9412 27.367 10.4322 27.367 8.57117C27.367 6.71017 25.858 5.20117 23.997 5.20117C22.136 5.20117 20.627 6.71017 20.627 8.57117C20.627 10.4322 22.136 11.9412 23.997 11.9412Z"
      fill="#1D7AFC"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_466"
        x1="15.989"
        y1="43.1032"
        x2="14.6109"
        y2="6.93924"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" stopColor="#1D7AFC" />
        <stop offset="1" stopColor="#0055CC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_466"
        x1="42.4099"
        y1="26.2853"
        x2="26.3829"
        y2="42.8553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0055CC" />
        <stop offset="1" stopColor="#0055CC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_818_466"
        x1="33.051"
        y1="6.59421"
        x2="33.051"
        y2="24.6962"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D7AFC" />
        <stop offset="0.59" stopColor="#1D7AFC" />
        <stop offset="1" stopColor="#0055CC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_818_466"
        x1="6.06095"
        y1="25.546"
        x2="32.268"
        y2="25.546"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.26" stopColor="#1D7AFC" />
        <stop offset="1" stopColor="#0055CC" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_818_466"
        x1="34.6069"
        y1="29.777"
        x2="40.3299"
        y2="23.692"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0055CC" />
        <stop offset="1" stopColor="#0055CC" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_818_466"
        x1="28.2189"
        y1="42.798"
        x2="28.2189"
        y2="8.20996"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.36" stopColor="#1D7AFC" />
        <stop offset="1" stopColor="#0055CC" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_818_466"
        x1="19.633"
        y1="42.7981"
        x2="19.633"
        y2="8.22312"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.06" stopColor="#1D7AFC" />
        <stop offset="0.58" stopColor="#0055CC" />
        <stop offset="1" stopColor="#1D7AFC" />
      </linearGradient>
    </defs>
  </svg>
);
